module.exports = {"TXTCLI_Contact_Support":{"id":"TXTCLI_Contact_Support","defaultMessage":"Wenden Sie sich an den Support","track":"Contact Support"}}